var map = {
	"./ada.svg": 10860,
	"./arb.svg": 20337,
	"./bnb.svg": 79482,
	"./btc.svg": 27245,
	"./doge.svg": 15511,
	"./eth.svg": 84201,
	"./ftt.svg": 13886,
	"./link.svg": 82336,
	"./sol.svg": 96582,
	"./uni.svg": 78586,
	"./xrp.svg": 96678
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94112;